const hosts = {
  local: {
    PRO: "localhost:3001",
    PRO_LANDING: "localhost:3001",
    MEN: "",
    WOMEN: "",
    CUSTOMER: "localhost:3003",
    PROTOCOL: "http://"
  },
  dev: {
    PRO: "dev.dspro.guide",
    PRO_LANDING: "dev.dspro.guide",
    MEN: "dev.digitalsportsmen.com",
    WOMEN: "dev.digitalsportswomen.com",
    CUSTOMER: "dev-web.ds.guide",
    PROTOCOL: "https://"
  },
  qa: {
    PRO: "qa.dspro.guide",
    PRO_LANDING: "qa.dspro.guide",
    MEN: "qa.digitalsportsmen.com",
    WOMEN: "qa.digitalsportswomen.com",
    CUSTOMER: "qa-web.ds.guide",
    PROTOCOL: "https://"
  },
  staging: {
    PRO: "staging.dspro.guide",
    PRO_LANDING: "staging.dspro.guide",
    MEN: "staging.digitalsportsmen.com",
    WOMEN: "staging.digitalsportswomen.com",
    CUSTOMER: "staging-web.ds.guide",
    PROTOCOL: "https://"
  },
  prod: {
    PRO: "manage.dspro.guide",
    PRO_LANDING: "manage.dspro.guide",
    MEN: "digitalsportsmen.com",
    WOMEN: "digitalsportwomen.com",
    CUSTOMER: "ds.guide",
    PROTOCOL: "https://"
  }
}

export default hosts
